import React from 'react';
import { number, string } from 'prop-types';
import { N400 } from '@/colors/colorsV1';

const Close = ({ color, size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ stroke: color }}
  >
    <path
      d="M9.00006 1L1.00006 9"
      style={{ stroke: color }}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.00012 9L1.00012 1"
      style={{ stroke: color }}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

Close.propTypes = {
  color: string,
  size: number,
};

Close.defaultProps = {
  color: N400,
  size: 12,
};

export default Close;
